import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { sizes, fadeIn } from 'style';

type BgProps = {
  bg?: string;
  isLoading?: boolean;
};

export const Bg = styled.div<BgProps>`
  ${({ bg }) =>
    bg &&
    css`
      background-color: ${th(`colors.${bg}`)};
    `}

  ${({ isLoading }) =>
    isLoading &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      height: 100%;
    `}
`;

type StyledContainerProps = {
  paddingTop?: string;
};

export const StyledContainer = styled.div<StyledContainerProps>`
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: 100%;
  min-height: 100vh;
  padding: 40px 20px;
  padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  margin: 0 auto;
  animation: ${fadeIn} 0.25s linear;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  }

  @media ${sizes.desktop} {
    padding-top: 110px;
  }
`;
